import formatPrice from './format-price';

export type VoucherCode = string;
export type VoucherType = 'Percentage' | 'Fixed'

export interface Voucher {
  code: VoucherCode;
  discountType: VoucherType;
  discountValue: number;
  isValid: boolean;
}

const calculateVoucherDiscount = (voucher: Voucher, total: number): number => {
  if (voucher.discountType === 'Percentage') {
    return (voucher.discountValue / 100.0) * total;
  } else if (voucher.discountType === 'Fixed') {
    return voucher.discountValue;
  }
  throw Error(`Unknown voucher discount type: ${voucher.discountType}`);
};

const formatVoucherDiscount = (voucher: Voucher): string => {
  if (voucher.discountType === 'Percentage') {
    return `${voucher.discountValue}%`;
  } else if (voucher.discountType === 'Fixed') {
    return formatPrice(voucher.discountValue);
  }
  throw Error(`Unknown voucher discount type: ${voucher.discountType}`);
};

const applyVouchersToTotal = (vouchers: Voucher[], total: number) => {
  let newTotal = total;
  for (const voucher of vouchers) {
    newTotal = Math.max(0, newTotal - calculateVoucherDiscount(voucher, total));
  }
  return newTotal;
};

export const VoucherUtils = {
  calculateVoucherDiscount,
  formatVoucherDiscount,
  applyVouchersToTotal,
};
